const formatAmount = (value, numberDecimal = 2) => {
    const valueParts = value.toFixed(numberDecimal).split(".");
    valueParts[0] = valueParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return valueParts.join(".").replace('.', ',');
};
export const toEuro = (value, displayDecimal = true, addSpace = false, numberDecimal = 2) => {
    if (!value && value !== 0)
        return null;
    if (!displayDecimal && Number.isInteger(value))
        return addSpace ? `${value} €` : `${value}€`;
    return addSpace ? `${formatAmount(value, numberDecimal)} €` : `${formatAmount(value, numberDecimal)}€`;
};
export const toPercent = (value, addSpace = false) => {
    if (!value && value !== 0)
        return null;
    if (Number.isInteger(value))
        return addSpace ? `${value} %` : `${value}%`;
    return addSpace ? `${formatAmount(value)} %` : `${formatAmount(value)}%`;
};
export const unformat = (value) => {
    const formatted = value
        .replace(/\s/g, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') //https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
        .toLowerCase()
        .trim();
    return formatted;
};
export const removeSpaces = (input) => (!input ? '' : input.replace(/\s/g, ''));
export const handleDate = (date) => {
    const chunks = date.split('/');
    return `${chunks[2].trim()}-${chunks[1].trim()}-${chunks[0].trim()}`;
};
export const IsNullOrEmpty = (input) => {
    return !input || input === 'undefined' || input === 'null';
};
export const IsNullOrZero = (input) => {
    return !input;
};
export const flattenErrorMessage = (error) => {
    let finalMessage = '';
    if (!error) {
        return finalMessage;
    }
    if (error.Details === null || error.Details.errors === null || error.Details.errors === undefined || error.Details.errors.length === 0) {
        return error.Message;
    }
    error.Details.errors.forEach((validationError, index) => {
        finalMessage += validationError.message;
        if (index < error.Details.errors.length - 1) {
            finalMessage += '\n';
        }
    });
    return finalMessage;
};
export const firstLettertoUpperCase = (name) => {
    return name && name[0].toUpperCase() + name.substring(1);
};
export const capitalizeName = (name) => {
    return name
        .toLowerCase()
        .replace(/\d/g, '') // Remove numbers
        .replace(/\s{2,}/g, ' ') // Remove multiple spaces
        .replace(/_/g, '-') // Replace '_' -> '-'
        .trim()
        .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase()); // replace first letter to uppercase
};
export const concatTitle = (firstSection, secondSection) => {
    if (!firstSection || !secondSection)
        return '';
    return `${firstSection} - “${secondSection}”`;
};
export const getInitials = (firstName, lastName, length = 3) => {
    if (!firstName || !lastName)
        return '';
    const initial = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    if (length === 2)
        return initial;
    return initial + lastName.charAt(1).toUpperCase();
};
